import React from 'react'
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HeroImg2 from '../components/HeroImg2';
// import Work from '../components/Work';
import Work2 from '../components/Work2';

function Designs() {
  return (
    <>
    <Navbar />
    <HeroImg2 heading="DESIGNS PORT-FOLIO"/>
    <Work2 />
    <Footer />

    </>
  )
}

export default Designs
